export default __webpack_public_path__ + "assets/logo.46709fb3e9410d028cb1403702e8af7c.svg";